/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Cost_WarningInputs */

const en_byoa_cost_warning = /** @type {(inputs: Byoa_Cost_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI usage is billed straight to your provider account, not to Bystep.`)
};

const id_byoa_cost_warning = /** @type {(inputs: Byoa_Cost_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya pemakaian AI ditagih langsung ke akun penyediamu, bukan ke Bystep.`)
};

/**
* | output |
* | --- |
* | "AI usage is billed straight to your provider account, not to Bystep." |
*
* @param {Byoa_Cost_WarningInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_cost_warning = /** @type {((inputs?: Byoa_Cost_WarningInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Cost_WarningInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_cost_warning(inputs)
	return en_byoa_cost_warning(inputs)
});